import { useSelector } from 'react-redux';

export const NEW_USER_PROFILE_FLAG = 'new_user_profile_view';

/**
 * Link to the logged-in user's own profile: the React `/user` page when the
 * `new_user_profile_view` flag is on, the Django `/profile/` page otherwise.
 * Single source of truth: use it instead of composing the URL by hand. For
 * another user's profile use `useUserProfileLink`. Always an absolute URL,
 * like `useUserProfileLink`.
 *
 * @example
 * const ownProfileLink = useOwnProfileLink();
 * <Link href={ownProfileLink}>...</Link>
 *
 * @returns {string}
 */
function useOwnProfileLink() {
  const waffleFlags = useSelector(
    (state) => state.AuthSlice?.permissions?.waffle_flags
  );

  if (waffleFlags?.includes(NEW_USER_PROFILE_FLAG)) {
    return new URL('/user', window.location.origin).toString();
  }

  return `${localStorage.getItem('tokkoBrokerHost')}/profile/`;
}

export default useOwnProfileLink;
